import { browser } from '$app/environment';

/** User's IANA timezone (e.g. "Europe/Warsaw"). Resolved once at module load —
 *  the browser doesn't change its timezone mid-session.
 *
 *  SSR-safe: on the server we fall back to 'UTC' so timezone-dependent code
 *  doesn't accidentally bake the server's timezone into SSR'd HTML. Anything
 *  truly local-time-sensitive should re-resolve once hydrated (or use this
 *  inside a $derived inside a component, which re-runs on hydration). */
export const userTimezone = browser ? Intl.DateTimeFormat().resolvedOptions().timeZone : 'UTC';
